"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.definitionWithStaticTarget = exports.LineLabelStyle = exports.DeltaLabelStyle = exports.LineStyle = void 0;
var EffectiveDefinition_1 = require("../../models/EffectiveDefinition");
var ConstantCalculation_1 = require("../../transforms/calculations/ConstantCalculation");
var LineStyle;
(function (LineStyle) {
    LineStyle["SOLID"] = "solid";
    LineStyle["DASHED"] = "dashed";
})(LineStyle = exports.LineStyle || (exports.LineStyle = {}));
var DeltaLabelStyle;
(function (DeltaLabelStyle) {
    DeltaLabelStyle["TARGET_VALUE"] = "target-value";
    DeltaLabelStyle["HISTORICAL_DELTA"] = "historical-delta";
})(DeltaLabelStyle = exports.DeltaLabelStyle || (exports.DeltaLabelStyle = {}));
var LineLabelStyle;
(function (LineLabelStyle) {
    LineLabelStyle["LATEST_VALUE"] = "latest-value";
    LineLabelStyle["NONE"] = "none";
})(LineLabelStyle = exports.LineLabelStyle || (exports.LineLabelStyle = {}));
var definitionWithStaticTarget = function (definition, value) {
    var _a;
    var columnName = "static_threshold_".concat(value);
    var newFeatures = __assign(__assign({}, definition.features), { threshold: {
            thresholds: [
                {
                    lines: [
                        {
                            measure: { column: columnName },
                            style: {
                                hidden: false,
                                interactive: false,
                                deltaLabel: DeltaLabelStyle.TARGET_VALUE,
                                lineStyle: LineStyle.DASHED,
                                lineLabel: LineLabelStyle.LATEST_VALUE,
                            },
                        },
                    ],
                },
            ],
        } });
    var newSchema = __assign(__assign({}, definition.schema), (_a = {}, _a[columnName] = {
        type: EffectiveDefinition_1.NumberType,
        name: columnName,
        calculation: {
            type: ConstantCalculation_1.ConstantType,
            value: value,
        },
    }, _a));
    return __assign(__assign({}, definition), { features: newFeatures, schema: newSchema });
};
exports.definitionWithStaticTarget = definitionWithStaticTarget;
//# sourceMappingURL=models.js.map